module.exports = __webpack_public_path__ + "static/media/partner-store-flow2.fe237caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-flow2.png
// module id = 540
// module chunks = 0